import { Request } from './request'

export interface ProcessingParams {
  cautionEndTime?: string
  cautionStartTime?: string
  disposeEndTime?: string
  disposeStartTime?: string
  osIds?: string
  pn?: number
  ps?: number
  ruleMainCode?: string
  status?: number
  dataCode?: String
}

export function ProcessingPage(params: ProcessingParams): Request {
  return {
    url: '/api/data/center/dispose/list',
    method: 'POST',
    body: params,
  }
}

export function ProcessingDetail(id: number): Request {
  return {
    url: '/api/data/center/dispose/info',
    method: 'GET',
    params: {
      disposeId: id,
    },
  }
}
